// extracted by mini-css-extract-plugin
export var banner_content = "topBannerTwo-module--banner_content--d1ded";
export var banner_link_btn = "topBannerTwo-module--banner_link_btn--83940";
export var banner_link_img = "topBannerTwo-module--banner_link_img--23cf2";
export var banner_link_name = "topBannerTwo-module--banner_link_name--47408";
export var banner_title = "topBannerTwo-module--banner_title--e6f8f";
export var top_banner_two = "topBannerTwo-module--top_banner_two--45e87";
export var top_banner_two_space = "topBannerTwo-module--top_banner_two_space--792d4";